import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ControlledFormInput } from '../../../../Lib/Utils/FormUtils/ControlledFormInput';
import { AddTagFormData } from '../types';

export function BlockHeaderSection() {
  const { control } = useFormContext<AddTagFormData>();

  return (
    <div className="rounded-xl border border-neutral-200 shadow-sm p-5 space-y-4">
      <ControlledFormInput
        name="blockNumber"
        label="Block Number"
        control={control}
        inputType="text"
        required
        inputProps={{
          placeholder: 'Enter block number',
          className: 'w-full',
        }}
        rules={{
          required: 'Block number is required',
        }}
      />

      <ControlledFormInput
        name="category"
        label="Category"
        control={control}
        inputType="text"
        required
        inputProps={{
          placeholder: 'Enter category',
          className: 'w-full',
        }}
        rules={{
          required: 'Category is required',
        }}
      />
    </div>
  );
}
